import React from 'react';
import { Route } from 'react-router';
import BrandLayout from '../brands/containers/BrandLayout';
import ExpiredCard from './ExpiredCard';
import Migration from './Migration';

export default () => (
  <Route component={BrandLayout} path="/membership">
    <Route path="expired-card/:brandRoute/:customerId" component={ExpiredCard} />
    <Route path="migration/:brandRoute/:customerId" component={Migration} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/membership/routes.jsx